import { useFormContext } from 'react-hook-form';

import { StrategyFormData } from '../../../../../../providers/backtesting/types';
import { CollapsibleSection } from '../../components/collapsible-section';
import { BacktestingInput } from '../../components/backtesting-input';
import { BacktestingSelect } from '../../components/backtesting-select';
import { FormRow } from '../../components/form-row';

import './styles.scss';

const CATEGORY_OPTIONS = [{ name: 'Market', value: 'market' }];

const TOKEN_OPTIONS = [
  { name: 'BTC', value: 'BTC' },
  { name: 'ETH', value: 'ETH' },
  { name: 'SOL', value: 'SOL' },
];

const COMPARISON_OPTIONS = [
  { name: 'Equal to', value: 'eq' },
  { name: 'Not equal to', value: 'neq' },
  { name: 'Greater than', value: 'gt' },
  { name: 'Greater than or equal to', value: 'gte' },
  { name: 'Less than', value: 'lt' },
  { name: 'Less than or equal to', value: 'lte' },
];

export const EntryConditionsSection = () => {
  const { register, watch, setValue } = useFormContext<StrategyFormData>();

  const selectedCategory =
    CATEGORY_OPTIONS.find((o) => o.value === watch('entryConditions.category')) ??
    CATEGORY_OPTIONS[0];

  const selectedToken =
    TOKEN_OPTIONS.find((o) => o.value === watch('entryConditions.token')) ?? TOKEN_OPTIONS[0];

  const selectedComparison =
    COMPARISON_OPTIONS.find((o) => o.value === watch('entryConditions.comparison')) ??
    COMPARISON_OPTIONS[0];

  return (
    <CollapsibleSection title="Entry Conditions" defaultOpen={false}>
      <p className="entry-conditions-description">
        All entry conditions must be met for the trade to be executed at the execution time.
      </p>

      <div className="field-group entry-conditions-category">
        <label className="field-label">Category</label>
        <BacktestingSelect
          values={CATEGORY_OPTIONS}
          defaultValue={selectedCategory}
          onChange={(value) => setValue('entryConditions.category', value, { shouldDirty: true })}
        />
      </div>

      <FormRow columns={5}>
        <div className="field-group">
          <label className="field-label">Market conditions: Token</label>
          <BacktestingSelect
            size="fluid"
            values={TOKEN_OPTIONS}
            defaultValue={selectedToken}
            onChange={(value) => setValue('entryConditions.token', value, { shouldDirty: true })}
          />
        </div>

        <div className="field-group">
          <BacktestingInput
            size="fluid"
            label="Market conditions: Instrument"
            tooltip={`Instrument can include ATMF, 25C, 10P, 15RR, etc.`}
            placeholder="Instrument"
            {...register('entryConditions.instrument')}
          />
        </div>

        <div className="field-group">
          <BacktestingInput
            size="fluid"
            label="Market conditions: Tenor"
            tooltip={`Tenor can include`}
            placeholder="Tenor"
            {...register('entryConditions.tenor')}
          />
        </div>

        <div className="field-group">
          <label className="field-label">Comparison</label>
          <BacktestingSelect
            size="fluid"
            values={COMPARISON_OPTIONS}
            defaultValue={selectedComparison}
            onChange={(value) =>
              setValue('entryConditions.comparison', value, { shouldDirty: true })
            }
          />
        </div>

        <div className="field-group">
          <BacktestingInput
            size="fluid"
            label="Value"
            placeholder="Value"
            {...register('entryConditions.value')}
          />
        </div>
      </FormRow>
    </CollapsibleSection>
  );
};
